export default __webpack_public_path__ + "static/media/gallery-wip-flash-suppressor_11.04a47312.jpg";